module.exports = __webpack_public_path__ + "static/media/ergonomic-3.0cdebfdc.png";